<template>
  <v-col class="delivery-content">
    <v-row class="mb-4">
      <v-col>
        <h1 class="headline font-weight-bold mb-2">
          Delivery Reports
        </h1>
        <p class="body-1 coolgray--text mb-0">
          Use Pacing and Discrepancy reports to monitor delivery health,
          identify risk early, and keep campaign execution on track.
        </p>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'gauge-high']"
              class="primary--text mr-2"
            />
            Pacing Report
          </h2>

          <p class="body-2 mb-3">
            Pacing shows whether line items are ahead, on track, or behind
            expected delivery over the campaign window.
          </p>

          <ul class="body-2 mb-0">
            <li><strong>Pacing %:</strong> Actual vs expected delivery.</li>
            <li><strong>Lifetime Goal:</strong> Total target impressions/clicks.</li>
            <li><strong>Delivered:</strong> What has shipped so far.</li>
            <li><strong>Remaining:</strong> Volume left before end date.</li>
            <li><strong>Days Remaining:</strong> Time left to recover pacing gaps.</li>
          </ul>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'scale-balanced']"
              class="warning--text mr-2"
            />
            Discrepancy Report
          </h2>

          <p class="body-2 mb-3">
            Discrepancy compares Google Ad Manager counts against third-party
            systems to expose measurement drift and billing risk.
          </p>

          <ul class="body-2 mb-0">
            <li><strong>GAM Impressions:</strong> Google Ad Manager count.</li>
            <li><strong>Third-Party Impressions:</strong> External ad server count.</li>
            <li><strong>Discrepancy %:</strong> Relative difference between systems.</li>
            <li><strong>Revenue Impact:</strong> Estimated impact from discrepancy.</li>
          </ul>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'list-check']"
              class="success--text mr-2"
            />
            Typical Workflow
          </h2>

          <ol class="body-2 mb-0">
            <li class="mb-2">
              Select a network from global search/context.
            </li>
            <li class="mb-2">
              Apply filters for advertiser, order, line item, or status.
            </li>
            <li class="mb-2">
              Group data for triage by client, campaign, or owner.
            </li>
            <li>
              Export the current view for handoff and investigation.
            </li>
          </ol>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'DeliveryContent',
}
</script>

<style lang="scss" scoped>
.delivery-content {
  max-width: 900px;
}

ul, ol {
  padding-left: 20px;
}
</style>
